import * as React from 'react';
import { DisplayDate, formatShortMonthDay } from 'owa-datetime';
import { observer } from 'mobx-react-lite';
let classNames = require('classnames');
let styles = require('./CalendarAllDaySurfaceItem.scss');

export interface ContinuationDateProps {
    date: DisplayDate;
}

const ContinuationDate = observer(function ContinuationDate(props: ContinuationDateProps) {
    return (
        <div className={classNames(styles.icon, styles.continuationDate)}>
            {formatShortMonthDay(props.date)}
        </div>
    );
});
export default ContinuationDate;
